import React from "react"
import "../css/font-awesome.css"

const Footer = () => {
  let currentYear = new Date().getFullYear()
  return (
    <footer className="site-footer">
      <div className="footer_inner">
        <div className="container footer-container">
          <div style={{ textAlign: "left" }} className="footer-left">
            <div style={{ margin: 0 }} className="site-info footer-text">
              ООО "РЕАЛ"
            </div>
            <div className="site-info footer-text">ИНН: 2225154243</div>
            <div className="footer-text ">© {currentYear} ООО "РЕАЛ"</div>
            <div className="footer-text ">
              Разработано:{" "}
              <a target={"_blank"} href={"https://ooo31.com/"}>
                ООО “31”
              </a>
            </div>
          </div>
          <div style={{ textAlign: "left" }} className="footer-center">
            <p>
              <a
                className="footer-text"
                href="https://nazaton.ru/policy"
                target="_blank"
              >
                Политика конфиденциальности
              </a>
            </p>
            <p>
              <a
                className="footer-text"
                href="https://nazaton.ru/processing-policy"
                target="_blank"
              >
                Политика обработки персональных данных
              </a>
            </p>
            <p>
              <a
                className="footer-text"
                href="https://nazaton.ru/user-agreement"
                target="_blank"
              >
                Пользовательское соглашение
              </a>
            </p>
            <p>
              <a
                className="footer-text"
                href="https://nazaton.ru/processing-agreement"
                target="_blank"
              >
                Согласие на обработку персональных данных
              </a>
            </p>
            <p>
              <a
                className="footer-text"
                href="https://nazaton.ru/processing-analytics"
                target="_blank"
              >
                Согласие на обработку данных системами веб-аналитики
              </a>
            </p>
          </div>
          <div className="footer-right">
            <span className="footer-title">Контакты:</span>
            <span className="footer-text">
              <i className="fa fa-map-marker-alt" /> г. Барнаул, п. Затон,
              ул.Водников 1е
            </span>
            <br />
            <a href="tel:+73852235555" className="footer-text">
              <i className="fa fa-phone" /> +7 3852 23-55-55
            </a>
            <br />
            <a href="tel:+73852235555" className="footer-text">
              <i className="fa fa-phone" /> +7 964 087-55-55
            </a>
            <br />
            <a
              className="footer-link"
              href="https://www.instagram.com/accounts/login/?next=/perviykurort/"
            >
              instagram:@perviykurort
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
